import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal, SectionEyebrow } from "@/components/shared/Reveal";
import { CONTACT_INFO } from "@/lib/pulseConstants";
import { handlePulseBriefClick } from "@/lib/pulseBriefCta";

export default function FinalCTASection() {
    return (
        <section className="section-pad relative overflow-hidden" data-testid="home-final-cta-section">
            <motion.div
                initial={{ opacity: 0.4 }}
                whileInView={{ opacity: 0.9 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2 }}
                className="absolute -top-40 left-1/2 -translate-x-1/2 h-[560px] w-[560px] rounded-full bg-[#FF2A2A]/12 blur-3xl pointer-events-none"
                aria-hidden="true"
            />
            <div className="container-editorial relative text-center">
                <SectionEyebrow index="09" label="Start The Conversation" className="justify-center" />
                <Reveal>
                    <h2 className="display-1 text-white text-balance">
                        Make your next brand moment
                        <br />
                        <span className="text-[#FF2A2A]">matter.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="body-lg max-w-2xl mx-auto mt-6">
                        Send us the brief. We will help shape the strategy, experience and amplification around it.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <Button
                            asChild
                            className="cta-glow bg-[#FF2A2A] hover:bg-[#ff4747] text-black font-semibold rounded-full h-14 px-8 text-base"
                            data-testid="final-primary-cta"
                        >
                            <Link to="/contact" onClick={handlePulseBriefClick} className="inline-flex items-center gap-2">
                                Start Your Pulse Brief
                                <ArrowUpRight size={18} />
                            </Link>
                        </Button>
                        <Button
                            asChild
                            variant="outline"
                            className="rounded-full border-white/25 bg-transparent hover:bg-white/5 text-white h-14 px-8 text-base"
                            data-testid="final-secondary-cta"
                        >
                            <a
                                href={`mailto:${CONTACT_INFO.email}`}
                                className="inline-flex items-center gap-2"
                            >
                                <Mail size={16} /> Email the Pulse Team
                            </a>
                        </Button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
